export default __webpack_public_path__ + "static/media/possibility_1.166c8469.png";